import { AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import axiosApis from '../../common/apis/axiosApis';

export type ModifyAircraftFleetAssignmentsParams = {
    company_id: number;
    aircraft_assignment_method: 'all' | 'fleet' | 'aircraft';
    aircrafts: number[] | null;
    fleets: number[] | null;
}

type ModifyAircraftFleetAssignmentsResponse = {
    message: string;
}

async function modifyFleetAssignments(userId: number, params: ModifyAircraftFleetAssignmentsParams)
    : Promise<AxiosResponse<ModifyAircraftFleetAssignmentsResponse>> {
  const userDetails = JSON.parse(localStorage.getItem('adminDetails')) as { token: string; };

  return axiosApis.put(`/admin/modifyUserAccountFleetAssignments/${userId}`, params, {
    headers: {
      Authorization: userDetails.token,
      'Content-Type': 'application/json',
    },
  });
}

type UseModifyAircraftFleetAssignments =
    UseMutationResult<AxiosResponse<ModifyAircraftFleetAssignmentsResponse>, Error, ModifyAircraftFleetAssignmentsParams, unknown>;

function useModifyAircraftFleetAssignments(userId: number): UseModifyAircraftFleetAssignments {
  return useMutation({
    mutationFn: (params) => modifyFleetAssignments(userId, params),
  });
}

export default useModifyAircraftFleetAssignments;
